module.exports = __webpack_public_path__ + "static/library-bc78aed26a6856092f2da5780c10a9d1.jpg";